"use strict";

var _regeneratorRuntime = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/regenerator");

var _slicedToArray = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/helpers/slicedToArray");

var _classCallCheck = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _assertThisInitialized = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/helpers/assertThisInitialized");

var _inherits = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/helpers/inherits");

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : new P(function (resolve) {
        resolve(result.value);
      }).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var Factory_1 = require("./Factory");

var Erc20TokenBalance_1 = require("../Erc20TokenBalance");
/**
 * Factory generates information for an ERC20 Token Balance
 */


var Erc20TokenBalanceFactory =
/*#__PURE__*/
function (_Factory_1$Factory) {
  _inherits(Erc20TokenBalanceFactory, _Factory_1$Factory);

  /**
   * Create an instance of the ERC20 Token Balance Factory
   */
  function Erc20TokenBalanceFactory(context) {
    var _this;

    _classCallCheck(this, Erc20TokenBalanceFactory);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Erc20TokenBalanceFactory).call(this, Erc20TokenBalance_1.Erc20TokenBalance, context));
    /**
     * @hidden
     */

    _this.generateProperties = function (uid) {
      return __awaiter(_assertThisInitialized(_this), void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee() {
        var _Erc20TokenBalance_1$, tokenAddress, walletAddress, token, _ref, _ref2, symbol, balance;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _Erc20TokenBalance_1$ = Erc20TokenBalance_1.Erc20TokenBalance.unserialize(uid), tokenAddress = _Erc20TokenBalance_1$.tokenAddress, walletAddress = _Erc20TokenBalance_1$.walletAddress;
                _context.next = 3;
                return this.context.contractWrappers.tokenFactory.getERC20TokenInstanceFromAddress(tokenAddress);

              case 3:
                token = _context.sent;
                _context.next = 6;
                return Promise.all([token.symbol(), token.balanceOf({
                  owner: walletAddress
                })]);

              case 6:
                _ref = _context.sent;
                _ref2 = _slicedToArray(_ref, 2);
                symbol = _ref2[0];
                balance = _ref2[1];
                return _context.abrupt("return", {
                  tokenSymbol: symbol,
                  balance: balance
                });

              case 11:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
    };

    return _this;
  }

  return Erc20TokenBalanceFactory;
}(Factory_1.Factory);

exports.Erc20TokenBalanceFactory = Erc20TokenBalanceFactory;